/*
 * Title: 매출조회
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디
 * - sponserName: 후원인 이름
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성
 */

import GentleWidget from "../common/widget";
import GentleLang from "../common/lang";
import GentleComponentButton from "../component/button";
import GentleComponentBubble from "../component/bubble";
import GentleComponentQuickReply from "../component/quickReply";
import GentleServiceProduct from "../service/product";
import GentleServiceSearch from "../service/search";
import GentleProxy from "../common/proxy";
import GentleUtil from "../common/util";
import GentleAppState from "../common/appstate";
import language from "../lang";
import Const from "../common/const";
import GentleServiceCallCenter from "../service/callCenter";

var GentleServiceSales = Object.create(GentleWidget, {
  sponserId: { writable: true, configurable: false, enumerable: true },
  sponserName: { writable: true, configurable: false, enumerable: true },
});
function leftPad(value) {
  if (value >= 10) {
    return value;
  } else {
    return `0${value}`;
  }
}
// 하위매출 조회
GentleServiceSales.main = function (data) {
  console.log("GentleServiceSales.main");

  {
    const bubble = GentleUtil.notSupported();
    bubble.insert();
    return;
  }

  const component = Object.create(this);
  const list = []; // 최신 세개의 레코드가 담김
  let today = new Date();

  let year = today.getFullYear(); // 년도
  let month = leftPad(today.getMonth() + 1); // 월
  console.log("today.getMonth =>", today.getMonth());

  let date = leftPad(today.getDate()); // 날짜
  console.log("today.getDate() =>", today);
  let day = today.getDay(); // 요일
  let startDate = "";
  let endDate = "";
  // alert(year + '-' + month + '-' + date)
  let endMonthDay = new Date(year, month, 0).getDate();
  if (date < 14) {
    startDate = year + "-" + month + "-" + "01";
    endDate = year + "-" + month + "-" + "14";
  } else {
    startDate = year + "-" + month + "-" + "15";
    endDate = year + "-" + month + "-" + endMonthDay;
  }
  console.log(
    "현재의 날짜는" +
      month +
      "-" +
      date +
      "이며, \n" +
      "정산기간은 " +
      startDate +
      "부터" +
      endDate +
      "까지입니다."
  );
  // api
  const request = function () {
    const PageNo = 1;
    const PageSize = 5;

    // todo : api 수정되면 반영
    // const StartDate = '';
    // const EndDate = '';
    let StartDate = startDate;
    let EndDate = endDate;
    const onSuccess = function (data) {
      console.log("onSuccess>", data);
      switch (data.result) {
        case "200":
          const { item } = data;
          const { Data } = item;
          console.log("Data>", Data);

          if (Data.length > 0) {
            const array = Data;
            for (let index = 0; index < array.length && index < 3; index++) {
              const element = array[index];
              // list.unshift(element);
              list.push(element);
            }
          }

          render(list);
          break;
        default:
          break;
      }
    };

    const onFailed = function (data) {
      console.log("onFailed");
    };

    const proxy = Object.create(GentleProxy);
    const param = { PageNo, PageSize, StartDate, EndDate };

    proxy.request("global-huwonbonus", param, onSuccess, onFailed);
  };
  request();

  let $left, $right, $small;

  function updateData(data) {
    if (data) {
      console.log("updateData>", data);
      // todo : bind
      let leftPV = data.Left.TodayPv;
      let rightPV = data.Right.TodayPv;
      let small = leftPV < rightPV ? leftPV : rightPV;

      leftPV = GentleUtil.comma(leftPV);
      rightPV = GentleUtil.comma(rightPV);
      small = GentleUtil.comma(small);

      $left.html(leftPV);
      $right.html(rightPV);
      $small.html(small);
    }
  }

  const render = function (data) {
    console.log("render>", data);
    // 최근3개 레코드로 오래된것부터(0)

    // todo : 데이터가 없는 경우
    if (data.length === 0) {
      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html: GentleLang.translateService(
          language.sale,
          language.sale.type.Not3Days
        ),
      });
      bubble.insert();

      return;
    }

    // 봇버블
    {
      const name = GentleAppState.custName;
      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html: GentleLang.translateService(
          language.sale,
          language.sale.type.Day3,
          { name }
        ),
      });
      bubble.insert();
    }

    //
    {
      let $timeLabel;
      // todo :

      const left = GentleLang.translate(GentleLang.type.Left);
      const right = GentleLang.translate(GentleLang.type.Right);
      const small = GentleLang.translate(GentleLang.type.SmallSales);

      let dateString1 = "",
        dateString2 = "",
        dateString3 = "";
      if (list[0]) dateString1 = list[0].Date;
      if (list[1]) dateString2 = list[1].Date;
      if (list[2]) dateString3 = list[2].Date;
      console.log("datelist >>>", list);
      let html = `
            <div class="card-view">
                <div class="down-sales-container">
                    <ul class="date-tab">
                        <li class="active" name="date1">${dateString1}</li>
                        <li  name="date2">${dateString2}</li>
                        <li  name="date3">${dateString3}</li>
                    </ul>
                    <div class="account-box" style="margin-top:0;">
                        <p><span class="time-label"></span></p>
                        <div class="flex-box-2 center">
                            <div>
                                <strong>${left}</strong>
                                <hr class="mt-8">
                                <strong><em name="left"></em> PV</strong>
                            </div>
                            <div>
                                <strong>${right}</strong>
                                <hr class="mt-8">
                                <strong><em name="right"></em> PV</strong>
                            </div>
                        </div>
                        <div class="flex-box-2 space-beetween">
                            <span><strong>${small}</strong></span>
                            <span><strong name="small"></strong> PV</span>
                        </div>
                    </div>
                </div>
            </div>
            `;

      // component 초기화. 이 코드 후에 레퍼런스로 접근
      {
        let $container = $(html);
        component.setPrefix("sales");
        component.init($container);
        component.insert();
      }

      let $date1, $date2, $date3;
      const reset = function () {
        $date1.removeClass("active");
        $date2.removeClass("active");
        $date3.removeClass("active");
      };

      // bind
      {
        $left = component.find('[name="left"]');
        $right = component.find('[name="right"]');
        $small = component.find('[name="small"]');

        $date1 = component.find('[name="date1"]');
        $date2 = component.find('[name="date2"]');
        $date3 = component.find('[name="date3"]');

        $timeLabel = component.find(".time-label");

        // 첫 레코드 셋팅
        {
          const data = list[0];
          console.log("list>", list);
          updateData(data);
        }

        GentleProxy.requestBaseTime(function (date) {
          console.log(date);
          const str = GentleLang.translateService(
            language.bonus,
            language.bonus.type.BasedTime,
            { date }
          );
          $timeLabel.html(str);
        });

        $date1.bind("click", function () {
          console.log("1구간");

          // todo : data bind
          const data = list[0];
          updateData(data);
          reset();
          $date1.addClass("active");
        });

        $date2.bind("click", function () {
          console.log("2구간");

          // todo : data bind
          const data = list[1];
          updateData(data);

          reset();
          $date2.addClass("active");
        });

        $date3.bind("click", function () {
          console.log("3구간");

          const data = list[2];
          updateData(data);

          reset();
          $date3.addClass("active");
        });
      }
    }

    // quickReplay
    {
      const buttons = [
        // 나의 매출내역
        {
          isHidden: true,
          title: GentleLang.translateService(
            language.sale,
            language.sale.type.Me
          ),
          onClick: function () {
            GentleServiceSales.popupMySales();
          },
        },
        // 소실적 추천상품
        {
          title: GentleLang.translateService(
            language.sale,
            language.sale.type.Recommend
          ),
          text: GentleLang.translateService(
            language.sale,
            language.sale.type.Recommend
          ),
          onClick: function () {
            // 소실적 맞춤 상품 추천
            // GentleServiceSales.recommend();
          },
        },
        // 수당내역
        {
          title: GentleLang.translateService(
            language.sale,
            language.sale.type.Income
          ),
          text: GentleLang.translateService(
            language.sale,
            language.sale.type.Income
          ),
          onClick: function () {
            // GentleServiceBonus.main();
          },
        },
      ];
      var quickReply = Object.create(GentleComponentQuickReply);
      quickReply.createComponent(buttons);
      quickReply.insert();
    }
    GentleUtil.timeStamp();
  };
};

// 나의 매출내역
GentleServiceSales.popupMySales = function () {
  console.log("GentleServiceSales.popupMySales");
  //20221017
  // GentleUtil.updateSSOToken();

  {
    const bubble = GentleUtil.notSupported();
    bubble.insert();
    return;
  }

  const request = function () {
    GentleUtil.serviceLoadingShow();

    const onSuccess = function (data) {
      console.log("나의 매출 조회");
      console.log("onSuccess>", data);
      switch (data.result) {
        case "200":
          const { items } = data;
          console.log("items > ", items);

          if (items.length > 0) {
            render(data);
          } else {
            //user bubble: 나의 매출내역
            {
              const html = GentleLang.translateService(
                language.sale,
                language.sale.type.Me
              );
              var bubble = Object.create(GentleComponentBubble);
              bubble.insertUserBubble({ html, send: false });
              bubble.insert();
            }
            //bot bubble
            {
              // 이 미경님, 최근 N개월간 회원님의 매출이 존재하지 않습니다.
              const name = GentleAppState.custName;
              const html = GentleLang.translateService(
                language.sale,
                language.sale.type.NotFound,
                { name }
              );
              var bubble = Object.create(GentleComponentBubble);
              bubble.createComponent({
                html,
              });
              bubble.insert();
            }
          }

          break;
        default:
          break;
      }
    };

    const onFailed = function (data) {
      console.log("popupMySales onFailed");
    };

    const proxy = Object.create(GentleProxy);

    const custNo = GentleAppState.custNo;

    const param = { CustNo: custNo };
    console.log("mysales Params > ", param);

    // 나의 매출조회
    console.log("request orders");
    proxy.request("mysales", param, onSuccess, onFailed);
    // proxy.request("global-orders", param, onSuccess, onFailed);
  };

  const requestPV = function () {
    request();
  };

  requestPV();

  const render = function (data) {
    const { TotalCount } = data;
    const List = data.items;
    // 고정문구
    const title = GentleLang.translateService(
      language.sale,
      language.sale.type.Me
    );
    const info = GentleLang.translateService(
      language.sale,
      language.sale.type.MySalesInfo
    );
    const titleTotalPv = GentleLang.translate(GentleLang.type.TotalPv);
    const titleTotalSales = GentleLang.translateService(
      language.sale,
      language.sale.type.Total
    );
    const titleButton = GentleLang.translateService(
      language.sale,
      language.sale.type.More
    );

    const myPV = List.reduce((acc, curr) => {
      return acc + curr.sale_pv;
    }, 0);

    const totalPv = GentleUtil.comma(myPV); // todo
    const totalSales = GentleLang.translate(GentleLang.type.CurrencyFormat3, {
      num: "000",
    });

    let html = `
        <div id="sales-container">            
            <p class="info-box">
                <img src="/assets/images/atomy/popup_informatino.png" srcset="/assets/images/atomy/popup_informatino@2x.png 2x">
                ${info}
            </p>
            <div class="sales-summary">
                <div class="flex-box space-between">
                    <span><strong>${titleTotalPv}</strong></span>
                    <span><strong class="pv">${totalPv}</strong> PV</span>
                </div>
                <!--
                <div class="flex-box space-between">
                    <span><strong>${titleTotalSales}</strong></span>
                    <span>${totalSales}</span>
                </div>
                --!>
            </div>
            <ul name="list">
            </ul>
            <div id="fixed-bottom-layer">
            <div class="gentle-button-group margin-zero">
                <div class="wide-button">
                <button type="button" class="big square primary default">${titleButton}</button>
                </div>
            </div>
            </div>
        </div>        
        `;
    const $container = $(html);

    $container.find("button").bind("click", function () {
      var redirectUrl = GentleAppState.isPc
        ? language.url.pc.ViewMoreSales
        : language.url.mobile.ViewMoreSales;
      GentleUtil.ssoOpen(redirectUrl);
      console.log("더 많은 매출내역 보기 > 외부", redirectUrl);
    });

    const $list = $container.find('[name="list"]');
    console.log("list>>salenum", $list);

    console.log("List>", List);
    for (let index = 0; index < List.length; index++) {
      const element = List[index];
      const { prod_qty } = element;

      const { product } = element;

      // SaleNum, PVAmount
      const {
        prod_nm, //name
        ord_no,
        OrderInputType,
      } = element;
      if (element.orderdata === null) continue; // 주문데이터 없음

      const { totalPrice, totalPointValue, OrderStatusType, created } =
        element.orderdata;
      console.log("OrderStatusType", OrderStatusType);

      if (OrderStatusType === Const.OrderStatusType.OrderCancel) continue; // 주문취소
      if (OrderStatusType === Const.OrderStatusType.PayCancel) continue; // 결제취소
      if (OrderStatusType === Const.OrderStatusType.UnPaid) continue; // 미결제마감

      // bind
      const amount = GentleLang.translateService(
        language.sale,
        language.sale.type.SaleAmount,
        { num: prod_qty }
      );
      const pv = GentleUtil.comma(totalPointValue);
      const price = GentleLang.translate(GentleLang.type.CurrencyFormat3, {
        num: GentleUtil.comma(totalPrice),
      });

      let html = `
            <li>
                <span class="time-label">${created.slice(0, 10)}</span>
                <div class="flex-box space-between">
                    <span><strong>${prod_nm}</strong></span>
                    <span>
                        <strong class="pv">${pv}</strong> PV<br>
                        ${price}
                    </span>
                </div>
                <div class="flex-box space-between qty">
                    <span>${amount}</span>
                    <span>${ord_no}</span>
                </div>
            </li>
            `;
      const $card = $(html);
      $list.append($card);
    }

    console.log("container>", $container);
    GentleUtil.createSlidePopup({ title, content: $container });
  };
};

// 소실적 맞춤 상품 추천
GentleServiceSales.recommend = function () {
  console.log("GentleServiceSales.recommend");

  {
    const bubble = GentleUtil.notSupported();
    bubble.insert();
    return;
  }
  // GentleServiceCallCenter.disabledAPI();

  let today = new Date();

  let year = today.getFullYear(); // 년도
  let month = leftPad(today.getMonth() + 1); // 월
  let date = leftPad(today.getDate()); // 날짜

  let startDate = "";
  let endDate = "";
  // alert(year + '-' + month + '-' + date)
  let endMonthDay = new Date(year, month, 0).getDate();
  if (date < 14) {
    startDate = year + "-" + month + "-" + "01";
    endDate = year + "-" + month + "-" + "14";
  } else {
    startDate = year + "-" + month + "-" + "15";
    endDate = year + "-" + month + "-" + endMonthDay;
  }
  let StartDate = startDate;
  let EndDate = endDate;
  // api
  const request = function () {
    const pageSize = 5;

    const onSuccess = function (data) {
      console.log("onSuccess>", data);
      switch (data.resultMessage) {
        case "SUCCESS":
          const { Data } = data.item;
          console.log("Data>", Data);
          render(Data);
          break;
        default:
          break;
      }
    };

    const onFailed = function (data) {
      console.log("onFailed");
    };
    const custNo = GentleAppState.custNo;
    const proxy = Object.create(GentleProxy);
    const param = { custNo, PageNo: 1, PageSize: 3, StartDate, EndDate };

    proxy.request("global-huwonbonus", param, onSuccess, onFailed);
  };

  request();
  const render = function (array) {
    console.log("render>", array);

    if (array.length === 0) {
      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html: GentleLang.translateService(
          language.sale,
          language.sale.type.Not3Days
        ),
      });
      bubble.insert();

      return;
    }

    // let list = array;

    let list = [];
    // 무의미한 값 빼기
    array.forEach((element) => {
      const { Dealership, CurrentGrade, MaintainedGrade } = element;
      if (Dealership == 0 && CurrentGrade == 0 && MaintainedGrade == 0) {
        // ignore
      } else {
        list.push(element);
      }
    });

    // 최대 최근 3일치
    while (list.length > 3) {
      list = list.filter((day, index) => {
        if (index < 3) {
          return day;
        }
      });
      console.log("list.length>", list);
    }

    // 봇버블
    {
      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html: GentleLang.translateService(
          language.sale,
          language.sale.type.RecommendBot
        ),
      });
      bubble.insert();
    }

    // button
    let i = 0;
    list.forEach((element) => {
      const { Date } = element;
      const temp = Date.split("-");
      console.log(element);
      const month = Number(temp[1]);
      const date = Number(temp[2]);
      const text = GentleLang.translateService(
        language.sale,
        language.sale.type.RecommendButton,
        { month, date }
      );
      const isSecondary = i === 0 ? false : true;
      const option = [
        {
          send: false,
          isSecondary,
          text: text,
          user: "user",
          onClick: function () {
            GentleServiceSales.recommendDetail(element);
          },
        },
      ];
      var button = Object.create(GentleComponentButton);
      button.createComponent(option);
      button.insert();
      i++;
    });

    GentleUtil.timeStamp();
  };
};

GentleServiceSales.recommendDetail = function (data) {
  console.log("GentleServiceSales.recommendDetail>", data);
  const component = Object.create(this);

  const render = function (data) {
    console.log(data);
    // todo : data bind
    let { Date, Left, Right } = data;

    // todo : 필드 확인할 것
    let { TodayPv: leftPV } = Left;
    let { TodayPv: rightPV } = Right;

    leftPV = Number(leftPV);
    rightPV = Number(rightPV);

    const levelPoint = GentleUtil.levelPoint(GentleAppState.CurrentMastership);
    let skip = false;
    const min = 300000;
    let recommend = min;

    // 봇버블
    {
      let html1 = "";
      let html2 = GentleLang.translateService(
        language.sale,
        language.sale.type.DetailComment
      );

      const top = leftPV > rightPV ? leftPV : rightPV;

      // 등급의 다음 값
      const nextPoint = function (point) {
        if (point < 300000) point = 300000;
        else if (point >= 300000 && point < 700000) point = 700000;
        else if (point >= 700000 && point < 1500000) point = 1500000;
        else if (point >= 1500000 && point < 2400000) point = 2400000;
        else if (point >= 2400000 && point < 6000000) point = 6000000;
        else if (point >= 6000000 && point < 20000000) point = 20000000;
        else if (point >= 20000000 && point < 50000000) point = 50000000;

        return point;
      };

      // 등급의 최소값
      const bottomPoint = function (point) {
        let bottom;

        if (point >= 300000 && point < 700000) bottom = 300000;
        else if (point >= 700000 && point < 1500000) bottom = 700000;
        else if (point >= 1500000 && point < 2400000) bottom = 1500000;
        else if (point >= 2400000 && point < 6000000) bottom = 2400000;
        else if (point >= 6000000 && point < 20000000) bottom = 6000000;
        else if (point >= 20000000 && point < 50000000) bottom = 20000000;

        return bottom;
      };

      if (leftPV < min && rightPV < min) {
        html1 = GentleLang.translateService(
          language.sale,
          language.sale.type.BothLess
        );
        recommend = leftPV < rightPV ? min - leftPV : min - rightPV;
        recommend += 50000;
      } else if (rightPV == leftPV) {
        skip = true;
        html1 = GentleLang.translateService(
          language.sale,
          language.sale.type.BothOver
        );
        html2 = GentleLang.translateService(
          language.sale,
          language.sale.type.DetailTitleSame
        );
      } else if (leftPV > rightPV) {
        const next = nextPoint(rightPV);
        console.log("next", next);

        const pv = GentleUtil.comma(leftPV - rightPV);
        html1 = GentleLang.translateService(
          language.sale,
          language.sale.type.RightLittle,
          { pv }
        );
        recommend = leftPV - rightPV + 50000;
      } else if (leftPV < rightPV) {
        // 좌측이 기준값 보다 작은 경우
        const next = nextPoint(leftPV);
        const pv = GentleUtil.comma(rightPV - leftPV);
        html1 = GentleLang.translateService(
          language.sale,
          language.sale.type.LeftLittle,
          { pv }
        );
        recommend = rightPV - leftPV + 50000;
      }

      {
        var bubble = Object.create(GentleComponentBubble);
        bubble.createComponent({
          html: [html1, html2],
        });
        bubble.insert();
      }
    }

    // 카드
    {
      const left = GentleLang.translate(GentleLang.type.Left);
      const right = GentleLang.translate(GentleLang.type.Right);

      let title = GentleLang.translateService(
        language.sale,
        language.sale.type.DetailTitleSame
      );

      let compare = GentleUtil.compareImage(leftPV, rightPV);
      GentleLang.translateService(
        language.sale,
        language.sale.type.DetailTitleLeft
      ); // 하위회원 선택

      let button_title = GentleLang.translateService(
        language.sale,
        language.sale.type.DetailButtonOther
      );

      if (leftPV > rightPV) {
        title = GentleLang.translateService(
          language.sale,
          language.sale.type.DetailTitleRight
        );
        button_title = GentleLang.translateService(
          language.sale,
          language.sale.type.DetailButtonProduct
        );
      } else if (leftPV < rightPV) {
        title = GentleLang.translateService(
          language.sale,
          language.sale.type.DetailTitleLeft
        );
        button_title = GentleLang.translateService(
          language.sale,
          language.sale.type.DetailButtonProduct
        );
      } else if (leftPV === rightPV && leftPV === 0) {
        button_title = GentleLang.translateService(
          language.sale,
          language.sale.type.DetailButtonProduct
        );
        title = GentleLang.translateService(
          language.sale,
          language.sale.type.NeedMoreBoth
        );
      }

      const leftPVStr = GentleUtil.comma(leftPV);
      const rightPVStr = GentleUtil.comma(rightPV);

      let html = `
            <div class="card-view">
                <div class="down-perfomance-container">
                    <h3>${title}</h3>
                    <div class="account-box" style="margin-top:0;">
                        <p><span class="time-label">${Date}</span></p>
                        <div class="flex-box-2">
                            <div>
                                <strong>${left}</strong>
                                <hr class="mt-8">
                                <strong><em>${leftPVStr}</em> PV</strong>
                            </div>
                            <div>
                                <img src="/assets/images/atomy/${compare}.svg">
                            </div>
                            <div>
                                <strong>${right}</strong>
                                <hr class="mt-8">
                                <strong><em>${rightPVStr}</em> PV</strong>
                            </div>
                        </div>
                        <div class="gentle-button-group">
                            <div class="wide-button">
                                <button type="button" class="primary default">${button_title}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            `;
      let $container = $(html);

      // component 초기화. 이 코드 후에 레퍼런스로 접근
      {
        component.setPrefix("search");
        component.init($container);
        component.insert();

        // todo : case별 버튼 타이틀 핸들러 셋팅
        // .prop('title', 'your new title');
        component.find("button").bind("click", function () {
          if (skip) {
            console.log("다른 일자 소실적 보기");
            // '소실적 맞춤 상품 추천' 발화
            {
              const html = GentleLang.translateService(
                language.sale,
                language.sale.type.Recommend
              );
              GentleComponentBubble.insertUserBubble({ html, send: false });
              GentleServiceSales.recommend();
            }
          } else {
            console.log("PV 맞춤상품 추천받기");
            GentleComponentBubble.insertUserBubble({
              html: button_title,
              send: false,
            }); // button_title
            // GentleServiceSales.recommendDetail(data);
            GentleServiceSales.recommendProduct(recommend);
          }
        });
      }
    }
    GentleUtil.timeStamp();
  }; // end of render

  render(data);
};

GentleServiceSales.recommendProduct = function (recommend) {
  console.log("GentleServiceSales.recommendProduct", recommend);
  // const component =  Object.create(this);

  {
    const bubble = GentleUtil.notSupported();
    bubble.insert();
    return;
  }

  const self = this;
  let SearchPvRange;
  let curPage = 0;

  // api
  const request = function (moreStart, moreEnd) {
    const onSuccess = function (data) {
      console.log("onSuccess>", data);
      switch (data.result) {
        case "200":
          console.log("Data>", data);
          render(data, moreStart, moreEnd);
          break;
        default:
          break;
      }
    };

    const onFailed = function (data) {
      console.log("onFailed");
    };
    const sortingOption = '[{"pvPrice":"desc"}]';
    const proxy = Object.create(GentleProxy);
    const param = { SearchPvRange, sortingOption };

    proxy.request("recommend-product", param, onSuccess, onFailed);
  };

  // request(PageNo);
  GentleProxy.requestUserInfo(function (Data) {
    const { Dealership } = Data;
    let point = GentleUtil.levelPoint(Dealership);

    switch (Dealership) {
      case 0: // 회원
      case 1: // 에이전트
        point = 300000;
        break;
      case 2: // 특약점
        point = 700000;
        break;
      case 3: // 특약점
        point = 1500000;
        break;
      case 4: // 특약점
        point = 2400000;
        break;
      default:
        break;
    }
    console.log("point>", point);
    console.log("small>", recommend);
    SearchPvRange = recommend; // + 50000;
    console.log("SearchPvRange : (point - small) >", SearchPvRange);
    request(0, 2);
  });

  const render = function (data, moreStart, moreEnd) {
    const component = Object.create(self);
    const { items: List } = data;

    // 봇버블
    {
      // data.pv
      let html;
      html = GentleLang.translateService(
        language.sale,
        language.sale.type.ShowProduct,
        { pv: GentleUtil.comma(recommend) }
      );
      if (moreStart > 1) {
        // 첫 페이지가 아닌 경우 '추천상품을 더 보여줄게요
        html = GentleLang.translateService(
          language.sale,
          language.sale.type.MoreProductBot
        );
      }
      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html,
      });
      bubble.insert();
    }
    {
      let html = `
            <div>
                <div class="list" name="list"}></div>
            </div>
            `;

      let $list;
      // component 초기화. 이 코드 후에 레퍼런스로 접근
      {
        let $container = $(html);
        component.setPrefix("search");
        component.init($container);
        component.insert();
        $list = component.find('[name="list"]');
      }
      const button_title = GentleLang.translate(
        GentleLang.type.ProductDetailView
      );
      for (let index = moreStart; index < moreEnd; index++) {
        const element = List[index];
        console.log(element);

        let {
          images,
          name,
          memRetailPrice: CustPrice,
          pvPrice: PvPrice,
        } = element;
        const ThumbImageUrl = images && images.length > 0 ? images[0].file : "";

        // todo : data bind badge
        let badge = "";
        {
          const {
            IsNew,
            IsSaleLimit,
            IsSaleSeason,
            IsSoldOut,
            IsReOpenNotifyMode,
          } = element;

          if (IsNew)
            badge += `
          <i class="at-badge at-new"></i>`;
          if (IsSaleLimit)
            badge += `
          <i class="at-badge at-limited"></i>`;
          if (IsSaleSeason)
            badge += `
          <i class="at-badge at-season"></i>`;
          if (IsSoldOut && IsReOpenNotifyMode)
            badge += `
          <i class="at-badge at-soldout"></i>`;
        }

        let pv = GentleUtil.comma(PvPrice);

        CustPrice = GentleUtil.comma(CustPrice);
        CustPrice = GentleLang.translate(GentleLang.type.CurrencyFormat3, {
          num: CustPrice,
        });

        let html = `
                <div class="card-view">
                    <div class="product-container default">
                        <div class="product-card">
                            <figure class="product-thumbnail">
                                <img src="${ThumbImageUrl}">
                            </figure>
                            <div class="product-summary">
                                <div class="flex-box">
                                    ${badge}
                                </div>
                                <h3>${name}</h3>
                                <div class="flex-box-2 space-beetween">
                                    <span>${CustPrice}</span>
                                    <span><strong class="pv">${pv}</strong> PV</span>
                                </div>
                            </div>
                        </div>
                        <div class="gentle-button-group">
                            <div class="half-button">
                                <button type="button" class="secondary default" name="copy">상품URL 복사</button>
                                <button type="button" class="primary default" name="cart">${button_title}</button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>`;

        const $card = $(html);

        {
          const onClickDetail = function () {
            console.log("clicked");
            GentleComponentBubble.insertUserBubble({ html: name, send: false });
            GentleServiceSearch.info(element);

            var quickReply = Object.create(GentleComponentQuickReply);

            // todo : 제품상세
            let buttons = [];
            {
              const onClickDetail = function () {
                console.log("language.product.type.Detail");
                let url = GentleAppState.isPc
                  ? language.url.pc.ProductDetails
                  : language.url.mobile.ProductDetails;
                console.log(element);

                const idChecking = (data) => {
                  if (data.materialCode === undefined) {
                    const { Id } = data;
                    return Id;
                  } else {
                    const { materialCode: Id } = data;
                    return Id;
                  }
                };

                const Id = idChecking(element);
                // const {Id} = element;
                url = url.GentleFormat({ Id });
                console.log("url>", url);
                window.open(url);
              };
              buttons = [
                {
                  send: false,
                  title: GentleLang.translateService(
                    language.product,
                    language.product.type.Detail
                  ),
                  onClick: onClickDetail,
                },
              ];
            }
            // buttons = buttons.concat(quickReplies);

            quickReply.createComponent(buttons);
            quickReply.insert();

            GentleUtil.timeStamp();
          };
          $card.find("div").eq(0).bind("click", onClickDetail);
        }

        $card.find('[name="cart"]').bind("click", function () {
          console.log("장바구니 담기>", element);
          GentleServiceProduct.popupOption(element);
        });

        $card.find('[name="copy"]').bind("click", function (event) {
          let urlCopy = GentleAppState.isPc
            ? language.url.pc.ProductDetails
            : language.url.mobile.ProductDetails;
          console.log(element);

          function idChecking(data) {
            if (data.materialCode === undefined) {
              const { Id } = data;
              return Id;
            } else {
              const { materialCode: Id } = data;
              return Id;
            }
          }

          const Id = idChecking(element);

          urlCopy = urlCopy.GentleFormat({ Id });

          console.log("링크복사>", urlCopy);

          GentleUtil.copyTextToClipboard(urlCopy, function (result) {
            if (result === true) {
              GentleUtil.createToastMessage(
                GentleLang.translate(GentleLang.type.CopiedURL)
              );
            } else {
              GentleUtil.createToastMessage(
                GentleLang.translate(GentleLang.type.FailedCopyURL)
              );
            }
          });
          event.stopPropagation();
        });

        // component.find(".list").append($card);
        // component.find('[name="list"]').append($card);
        $list.append($card);
      }
    }

    if (moreStart === 0 && List) {
      // 첫페이지인 경우
      if (moreStart === 0 && List.length > 1) {
        // 첫 페이지고 두가지 이상의 경우
        // 추천상품 더보기
        const text = GentleLang.translateService(
          language.sale,
          language.sale.type.MoreProduct
        );
        const option = [
          {
            send: false,
            isSecondary: true,
            isCardWidth: true,
            text: text,
            user: "user",
            onClick: function () {
              console.log("더보기");
              request(moreStart + 2, moreEnd + 2);
            },
          },
        ];
        var button = Object.create(GentleComponentButton);
        button.createComponent(option);
        button.insert();
      }
      // button
      {
        const text = GentleLang.translate(GentleLang.type.VisitVideo);
        const option = [
          {
            send: false,
            isHidden: true,
            isSecondary: true,
            isCardWidth: true,
            text: text,
            user: "user",
            onClick: function () {
              console.log(text);
              GentleAppState.isPc
                ? window.open(language.url.pc.ChannelAtomyMedia)
                : window.open(language.url.mobile.ChannelAtomyMedia);
            },
          },
        ];
        var button = Object.create(GentleComponentButton);
        button.createComponent(option);
        button.insert();
      }
    } // 2페이지부터
    else {
      // 이전 상품보기
      let text = GentleLang.translateService(
        language.product,
        language.product.type.Pre
      );
      const buttons = [
        {
          send: false,
          isSecondary: true,
          isCardWidth: true,
          text: text,
          user: "user",
          onClick: function () {
            console.log(text);
            // todo : 이전 상품 보기
            request(moreStart - 2, moreEnd - 2);
          },
        },
      ];

      if (moreEnd < List.length) {
        // 더 있는 경우
        text = GentleLang.translate(GentleLang.type.NextProducts);
        buttons.push({
          send: false,
          isSecondary: true,
          isCardWidth: true,
          text: text,
          user: "user",
          onClick: function () {
            console.log(text);
            request(moreStart + 2, moreEnd + 2);
          },
        });
      }

      var button = Object.create(GentleComponentButton);
      button.createComponent(buttons);
      button.insert();
    }

    // quickReplay
    {
      // 다른일자선택
      const title = GentleLang.translateService(
        language.sale,
        language.sale.type.SelectDate
      );
      const text = title;
      const buttons = [
        {
          send: false,
          title: title,
          text: text,
          onClick: function () {
            GentleServiceSales.recommend();
          },
        },
      ];
      var quickReply = Object.create(GentleComponentQuickReply);
      quickReply.createComponent(buttons);
      quickReply.insert();
    }
    GentleUtil.timeStamp();
  };
};

export default GentleServiceSales;
